import { MessageCircle, Send, Sparkles } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button, Field, Input, Modal, Textarea } from "./ui";

export function AiCollectionDraft({ loanId, onSent }: { loanId: string; onSent?: () => void }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [d, setD] = useState<any>(null);
  const [res, setRes] = useState<any>(null);

  const generate = async () => {
    setBusy(true); setRes(null);
    try { const { data } = await api.post("/ai/collection-draft", { loan_id: loanId }); setD(data); setOpen(true); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/ai/collection-send", { loan_id: loanId, title: d.title, body: d.body });
      setRes(data);
      toast.success(data.portal ? "Pesan dikirim ke HP siswa (notifikasi + inbox portal)" : "Pesan disimpan di inbox portal — siswa belum punya akses portal, kirim via WA");
      onSent?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <>
      <Button variant="outline" size="md" disabled={busy} onClick={generate} data-testid="ai-collection-button" title="Buat draft pesan tagihan personal dengan AI"><Sparkles className="h-4 w-4" /> {busy && !open ? "Menyusun…" : "Pesan Tagihan AI"}</Button>
      <Modal open={open} onClose={() => { setOpen(false); setRes(null); }} title="Draft Pesan Tagihan Personal (AI)" testId="ai-collection-modal">
        {d && (
          <div className="space-y-3">
            <p className="text-xs text-muted-foreground">Nada: <b>{d.tone}</b>{d.days_late > 0 ? ` · terlambat ${d.days_late} hari` : ""}. Periksa & sunting sebelum dikirim.</p>
            <Field label="Judul notifikasi"><Input data-testid="ai-collection-title" value={d.title} onChange={(e) => setD({ ...d, title: e.target.value })} /></Field>
            <Field label="Isi pesan"><Textarea data-testid="ai-collection-body" className="min-h-[160px]" value={d.body} onChange={(e) => setD({ ...d, body: e.target.value })} /></Field>
            {res ? (
              <div className="rounded-lg border border-emerald-300 bg-emerald-50 dark:bg-emerald-950/30 p-3 text-sm space-y-2" data-testid="ai-collection-result">
                <p className="font-semibold text-emerald-800 dark:text-emerald-200">Terkirim {res.portal ? "ke HP siswa & inbox portal" : "ke inbox portal (siswa belum punya akses HP)"}.</p>
                {res.wa_link ? <a href={res.wa_link} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 font-semibold text-emerald-700 hover:underline" data-testid="ai-collection-wa-link"><MessageCircle className="h-4 w-4" /> Kirim juga via WhatsApp</a> : <p className="text-xs text-muted-foreground">Nomor WA siswa/wali kosong.</p>}
              </div>
            ) : (
              <div className="flex flex-wrap justify-end gap-2">
                <Button type="button" variant="outline" disabled={busy} onClick={generate} data-testid="ai-collection-regenerate"><Sparkles className="h-4 w-4" /> Susun ulang</Button>
                <Button type="button" disabled={busy || d.body.trim().length < 10} onClick={send} data-testid="ai-collection-send"><Send className="h-4 w-4" /> {busy ? "Mengirim…" : "Kirim ke HP Siswa"}</Button>
              </div>
            )}
          </div>
        )}
      </Modal>
    </>
  );
}
